import { IacEnvironment } from '@iac-types';

export const IAC_ENVIRONMENT: IacEnvironment = {
  production: false,
  env: 'dev',
  storyblokToken: 'your-storyblok-token',
  storyblokEditModeToken: 'your-storyblok-token',
  storyblokPreviewToken: 'your-storyblok-token',
  api: {
    baseUrl: 'your-api-url',
  },
};
